import React from 'react'

import { useSaveChecklistType } from './_requests/saveChecklistType'
import ChecklistTypesLoader, { useChecklistTypes } from '../_load/ChecklistTypesLoader'
import LazySelect from '../../../components/form/LazySelect'
import { useSessionPermission } from '@btime/react-session'

const ChecklistTypesSelect = ({ onChange, ...props }) => {
  const createChecklistType = useSessionPermission('createChecklistType')
  const onSuccess = result => onChange(result.id, result.name, { origin: result, value: result.id, label: result.name })
  // const [{ loading }, onCreate] = useCreateChecklistTypeRequest(onSuccess)
  const [onCreate, { loading }] = useSaveChecklistType(onSuccess)

  return (
    <LazySelect
      Loader={ChecklistTypesLoader}
      dataHook={useChecklistTypes}
      onCreate={createChecklistType && onCreate}
      loading={loading}
      onChange={onChange}
      {...props}
    />
  )
}

export default ChecklistTypesSelect
